import { VideoActionType } from '../action/VideoAction';
import { addToHash, removeFromHash } from '../common/util';

const defaultState = {
  transcodingClimbIdMap: {},
  uploadingClimbIdPercentMap: {},
  successClimbIdUrlMap: {},
  successClimbIdThumbMap: {},
  error: '',
};

export default function VideoReducer(state = defaultState, action) {
  switch (action.type) {
    case VideoActionType.UPLOADING:
      return Object.assign({}, defaultState, {
        transcodingClimbIdMap: action.isTranscoding ? addToHash(action.climbId, true, state.transcodingClimbIdMap) : removeFromHash(action.climbId, state.transcodingClimbIdMap),
        uploadingClimbIdPercentMap: !action.isTranscoding && action.uploadPercent ? addToHash(action.climbId, action.uploadPercent, state.uploadingClimbIdPercentMap) : removeFromHash(action.climbId, state.uploadingClimbIdPercentMap),
        successClimbIdUrlMap: removeFromHash(action.climbId, state.successClimbIdUrlMap),
        successClimbIdThumbMap: removeFromHash(action.climbId, state.successClimbIdThumbMap),
      });
    case VideoActionType.UPLOAD_SUCCESS:
      return Object.assign({}, defaultState, {
        transcodingClimbIdMap: removeFromHash(action.climbId, state.transcodingClimbIdMap),
        uploadingClimbIdPercentMap: removeFromHash(action.climbId, state.uploadingClimbIdPercentMap),
        successClimbIdUrlMap: addToHash(action.climbId, action.url, state.successClimbIdUrlMap),
        successClimbIdThumbMap: addToHash(action.climbId, action.thumbUrl, state.successClimbIdThumbMap),
      });
    case VideoActionType.ERROR:
      return Object.assign({}, defaultState, {
        transcodingClimbIdMap: removeFromHash(action.climbId, state.transcodingClimbIdMap),
        uploadingClimbIdPercentMap: removeFromHash(action.climbId, state.uploadingClimbIdPercentMap),
        error: action.error,
      });
    default:
      break;
  }

  return state;
}
